// services/api/duyuruService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { DuyuruResponseModal } from "../../types/modals";
import { DuyuruError } from "../../types/ErrorModals/DuyuruError";
import { DuyuruRequestModal } from "../../types/RequestModals/DuyuruRequestModal";

export const getDuyurular = async (
  request: DuyuruRequestModal
): Promise<DuyuruResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<any[]>>(
      `${API_URL}/api/Duyurular/getDuyurular`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!.map((item) => ({
      ...item,
      baslik: item.aciklama?.trim() || "",
      icerik: item.aciklama2?.trim() || "",
      gonderen: item.gorusen?.trim() || "",
      kurumAdi: item.gorusulen?.trim() || "",
      displayTarih: item.tarih2 || new Date(),
      displaySaat:
        item.id16 && item.id16.length > 8
          ? item.id16.substring(item.id16.length - 8)
          : "",
    }));
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Duyuru bulunamadı",
          correlationId: responseData?.correlationId,
        } as DuyuruError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as DuyuruError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as DuyuruError;
    }

    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as DuyuruError;
  }
};
